
import { RegisteredProduct } from '~/models/warranty/RegisteredProduct'
import REGISTERED_PRODUCTS_QUERY from '~/queries/warranty/registeredProducts.gql'
import REGISTERED_PRODUCT_QUERY from '~/queries/warranty/registeredProduct.gql'

export default {
  data() {
    return { extendWarrantyModalOpen: false }
  },
  head() {
    return {
      title: this.$t('menu.nav_extend_warranty')
    }
  },
  apollo: {
    registeredProducts: {
      query: REGISTERED_PRODUCTS_QUERY,
      fetchPolicy: 'cache-and-network'
    },
    registeredProduct: {
      query: REGISTERED_PRODUCT_QUERY,
      fetchPolicy: 'cache-first',
      variables() {
        return {
          id: this.$route.params.id
        }
      },
      skip() {
        return !this.$route.params.id
      }
    }
  },
  computed: {
    hasMore() {
      return this.registeredProducts?.pageInfo?.hasNextPage ?? true
    },
    after() {
      return this.registeredProducts?.pageInfo?.endCursor
    },
    products() {
      const registeredProducts = this.registeredProducts?.results
      if (this.isLoading && !registeredProducts) return []
      const products = this.sortProducts([
        ...registeredProducts.map(RegisteredProduct.fromObject),
        ...this.$store.getters['warranty/products']
      ])
      products.unshift({ header: true })
      return products
    },
    product() {
      const registeredProduct = this.registeredProduct
        ? RegisteredProduct.fromObject(this.registeredProduct)
        : {}
      return (
        this.products.find((product) => product.id === this.$route.params.id) ??
        registeredProduct
      )
    },
    isLoading() {
      return this.$apollo.queries.registeredProducts.loading
    }
  },
  created() {
    this.$store.dispatch('warranty/loadProducts')
  },
  methods: {
    // sort in descending order, temporary measure to combine local and query data
    sortProducts(products) {
      products.sort((a, b) => {
        return b.registeredAt - a.registeredAt
      })
      return products
    },
    loadMore() {
      if (this.isLoading) return
      this.$apollo.queries.registeredProducts.fetchMore({
        variables: {
          after: this.after
        },
        updateQuery: (result, { fetchMoreResult }) => {
          const newResults = fetchMoreResult.registeredProducts.results
          const pageInfo = fetchMoreResult.registeredProducts.pageInfo

          result.registeredProducts.pageInfo = pageInfo
          result.registeredProducts.results.push(...newResults)

          return result
        }
      })
    }
  }
}
